import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import trackGTM from 'utils/trackGTM'
import GA4 from 'utils/GA4'
import { bp } from 'styles/breakpoints'
import { useComponentId, useFieldId } from 'utils/optimizely'
import Button from 'components/Button'
import Link from 'components/Link'
import { Title26 } from 'components/Typography'
import { Card, CardBody, Image } from './HomeGrid.style'
import { fixAudiences } from '../../utils/audiences'

const HomeGridCard = ({
  audiences,
  ctaLabel,
  ctaUrl,
  headline,
  image,
  compHeadline,
  villageSlug,
}) => {
  const [screenWidth, setScreenWidth] = useState(0)
  const { landscape, portrait } = image || { landscape: false, portrait: false }
  const hasAudiences = !!audiences
  const elementId = useComponentId(`Comp_grid_homepage_card_GRD02`)

  useEffect(() => {
    setScreenWidth(window.innerWidth)
    window.addEventListener('resize', () => setScreenWidth(window.innerWidth))
    return () => {
      window.removeEventListener('resize', () =>
        setScreenWidth(window.innerWidth)
      )
    }
  }, [])

  return (
    <Card
      hasAudience={hasAudiences}
      id={elementId}
      className={fixAudiences(audiences)}
      onClick={() =>
        GA4('grid_homepage_card_click', {
          headline,
          component_headline: compHeadline,
          village_name: villageSlug,
        })
      }>
      {!!image && (
        <Image
          image={
            screenWidth > parseInt(bp[2].replace('px', ''), 10)
              ? portrait?.gatsbyImageData || landscape?.gatsbyImageData
              : landscape?.gatsbyImageData || portrait?.gatsbyImageData
          }
          alt={image.altText || headline}
        />
      )}
      <CardBody>
        <Title26 id={useFieldId(elementId, 'title')}>{headline}</Title26>
        {!!ctaLabel && (
          <Button
            id={useFieldId(elementId, 'cta')}
            className="cta"
            as={Link}
            to={ctaUrl}
            onClick={() => {
              trackGTM('CTA', 'cta click', 'in page cta', ctaLabel)
            }}>
            {ctaLabel}
          </Button>
        )}
      </CardBody>
    </Card>
  )
}

const imgProp = PropTypes.shape({
  src: PropTypes.string,
  srcWebp: PropTypes.string,
})

HomeGridCard.propTypes = {
  audiences: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaUrl: PropTypes.string,
  headline: PropTypes.string,
  image: PropTypes.shape({
    altText: PropTypes.string,
    portrait: PropTypes.shape({
      retina: imgProp,
      standard: imgProp,
    }),
    landscape: PropTypes.shape({
      retina: imgProp,
      standard: imgProp,
    }),
  }),
  compHeadline: PropTypes.string,
  villageSlug: PropTypes.string,
}

HomeGridCard.defaultProps = {
  audiences: '',
  ctaLabel: '',
  ctaUrl: '',
  headline: '',
  image: {
    altText: '',
    landscape: {
      retina: '',
      standard: '',
    },
    portrait: {
      retina: '',
      standard: '',
    },
  },
  compHeadline: '',
  villageSlug: '',
}

export default HomeGridCard
